import React, { useState, useEffect } from "react";
import { StyleSheet, Platform } from "react-native";

import Dialog from "./index";

export default function ManaConfirmDialog(props) {
  const {
    title,
    description,
    isOpen = false,
    onClose = () => {},
    onConfirm = () => {},
    cancelText = "Cancel",
    confirmText = "Confirm",
    confirmTextColor,
  } = props;

  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    openDialog();
  }, [isOpen]);

  const openDialog = () => {
    setShowConfirmation(isOpen);
  };

  return (
    <>
      {showConfirmation ? (
        <Dialog.Container onClose={onClose}>
          <Dialog.Title>{title}</Dialog.Title>
          <Dialog.Description style={styles.confirmText}>
            {description}
          </Dialog.Description>

          {props.children}

          <Dialog.Button label={cancelText} onPress={onClose} />
          <Dialog.Button
            label={confirmText}
            onPress={onConfirm}
            color={confirmTextColor}
          />
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  confirmText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 13,
    lineHeight: 16,
    letterSpacing: -0.078,
    color: "#2D3142",
  },
});
